import { styled } from "@theme/stitches.config"

export const VideoWrapper = styled("div", {
    background: "black"
    // mb: 140,
    // "@mdDown": {
    //     mb: 60
    // }
})

export const IframeWrapper = styled("div", {
    height: "min(800px, calc(100vh - 80px))",
    width: 1920,
    maxWidth: "100%",
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    iframe: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%"
    }
})
